module.exports = __webpack_public_path__ + "img/gos-bg-mobile.e658d9a.jpg";